import { useState } from "react";
import { ITask } from "../../../data_models/task";
import Lightbox from "../../common/Lightbox";
import { FilledButton, OutlinedButton } from "../../common/Button";

import useDisplayNotifications from "../../../hooks/useDisplayNotifications";
import { DisplayNotificationType } from "../../../models/DisplayNotification";
import useProjectManagement from "../../../hooks/useProjectManagement";

interface UnassignMyselfLightboxProps {
    onClose: () => void;
    task: ITask;
    onUpdateTask: (updatedTask: ITask) => void;
}

const UnassignMyselfLightbox: React.FC<UnassignMyselfLightboxProps> = ({ onClose, task, onUpdateTask }) => {

    const [loading, setLoading] = useState(false);

    const { unassignFreelancer } = useProjectManagement();
    const { addNotification } = useDisplayNotifications();

    const onUnassign = async () => {
        try {
            setLoading(true);
            const result = await unassignFreelancer(task._id!);
            if (result) {
                onUpdateTask(result.task);
            }

        } catch (error: any) {
            addNotification({
                message: error.message,
                type: DisplayNotificationType.ERROR
            });
        } finally {
            setLoading(false);
            onClose();
        }
    }
    return (

        <Lightbox
            header="Step Out of Task"
            onClose={onClose}
            onCancel={onClose}
            onConfirm={onUnassign}
            confirmText="Unassign"
            confirmTheme="danger"
            loadingConfirm={loading}
            content={
                <p>Leaving is always an option, but any remaining unpaid portions of the task won’t be rewarded.</p>
            }
        />

    );
}

export default UnassignMyselfLightbox;